import React from 'react'
import * as S from './style';
import { ProfileImage, Label, SpaceDiv } from 'components';

import ServiceImageSample from 'assets/img/profile/img_service_example.png';

export default function ServicePopupContents() {
  return (
    <S.ContentsContainer>
      <S.ProfileExampleWrapper>
        <ProfileImage size={'XL'} background={ServiceImageSample} />
      </S.ProfileExampleWrapper>
      <S.ProfileGuideWrapper>
        위의 예시를 참고하시어 업체 로고를 등록해주세요. <br />
        아래 항목에 해당 될 경우에는 승인 되지 않습니다.
      </S.ProfileGuideWrapper>
      <S.InformationList margin={'0px 0px 8px 0px'}>
        <S.InformationItem>
          인물 사진
        </S.InformationItem>
        <S.InformationItem>
          업체 광고 및 연락처 노출
        </S.InformationItem>
      </S.InformationList>
      <S.LabelContainer>
        <Label
          fontStyle={'body2'}
          color={'gray_opacity_800'}
          contents={'업체 로고가 없을 경우에는 본인 명함을 올려주세요. 서류 확인 시, 짐싸에서 제작한 로고로 임시 변경해드립니다.'}
        />
        <SpaceDiv height={4} />
        <Label
          fontStyle={'subtitle'}
          color={'gray_opacity_600'}
          contents={
            '※ 짐싸에서 제작한 로고는 여러 업체가 중복으로 쓰게됩니다. 고객님의 선호도를 높이기 위해서는 개별적인 로고 등록을 추천드립니다.'
          }
        />
      </S.LabelContainer>
    </S.ContentsContainer>
  );
}
